import type { RequestAdminFeature } from "app/pages/sales-intelligence/types/requestAdminFeature";
import type { GetRequestOptions, IFetchService } from "app/services/fetchService";

const CONTACT_ADMIN_API = "/sales-api/contact-admin";

export interface IContactAdminApiService {
    /* @note fetch a list of admin emails related to current user */
    fetchAccountAdmins(options?: Readonly<GetRequestOptions>): Promise<string[]>;

    /* @note send email to admins to get the feature access */
    requestAccessFromAdmin(feature: RequestAdminFeature, options?: Readonly<GetRequestOptions>): Promise<void>;
}

const createContactAdminApiService = (fetchService: Readonly<IFetchService>): IContactAdminApiService => {
    return {
        fetchAccountAdmins(options?: Readonly<GetRequestOptions>): Promise<string[]> {
            return fetchService.get(CONTACT_ADMIN_API, undefined, options);
        },

        requestAccessFromAdmin(feature: RequestAdminFeature, options?: Readonly<GetRequestOptions>): Promise<void> {
            return fetchService.post(
                `${CONTACT_ADMIN_API}/request-access`,
                {
                    feature,
                },
                options,
            );
        },
    };
};

export default createContactAdminApiService;
